import * as React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';

interface Props {
	className?: string;
	count: number;
}

const BaggageCount: React.FC<Props> = ({ className, count }) => {
	const { BaggageCount: css } = useTheme('BaggageList');

	if (count === 0) {
		return null;
	}

	return <div className={cn(css.root, className)}>x{count}</div>;
};

export default BaggageCount;
